"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBarLogScale = exports.computeMaxNumberOfTicks = exports.useDateAxisTicks = exports.minTickDistance = exports.fallbackMaxNumberOfTicks = void 0;
var lodash_1 = require("lodash");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var react_1 = require("react");
var UnitFormatter_1 = __importDefault(require("../../services/UnitFormatter/UnitFormatter"));
var objectUtilities_1 = require("../../util/objectUtilities");
var miscHooks_1 = require("../miscHooks");
exports.fallbackMaxNumberOfTicks = 6;
exports.minTickDistance = 60;
var useDateAxisTicks = function (data) {
    var timeData = (0, objectUtilities_1.filterMap)(data, function (datum) { return datum.x; });
    var _a = __read((0, react_1.useState)(), 2), maxNumberOfTicks = _a[0], setMaxNumberOfTicks = _a[1];
    var containerRef = (0, react_1.useRef)(null);
    var getIsMounted = (0, miscHooks_1.useMountedState)();
    var updateMaxNumberOfTicks = (0, react_1.useCallback)(function () {
        if (getIsMounted()) {
            var newMaxNumberOfTicks = chartHooks.computeMaxNumberOfTicks(containerRef.current, maxNumberOfTicks);
            newMaxNumberOfTicks !== maxNumberOfTicks && setMaxNumberOfTicks(newMaxNumberOfTicks);
        }
    }, [getIsMounted, maxNumberOfTicks]);
    (0, react_1.useEffect)(updateMaxNumberOfTicks, [updateMaxNumberOfTicks]);
    (0, miscHooks_1.useWindowEventListener)('resize', updateMaxNumberOfTicks, 200);
    var axisTickInterval = Math.ceil(timeData.length / (maxNumberOfTicks || exports.fallbackMaxNumberOfTicks));
    var tickValuesX = (0, objectUtilities_1.filterMap)(timeData, function (date, index) { return !(index % axisTickInterval) && (0, moment_timezone_1.default)(date, UnitFormatter_1.default.isoDateFormat).toDate(); });
    return { tickValuesX: tickValuesX, containerRef: containerRef };
};
exports.useDateAxisTicks = useDateAxisTicks;
function computeMaxNumberOfTicks(container, maxNumberOfTicks) {
    return container ? Math.floor(container.clientWidth / exports.minTickDistance) : maxNumberOfTicks || exports.fallbackMaxNumberOfTicks;
}
exports.computeMaxNumberOfTicks = computeMaxNumberOfTicks;
var useBarLogScale = function (barData, numberOfYTicks) {
    var _a;
    var maximum = ((_a = (0, lodash_1.maxBy)(barData, 'value')) === null || _a === void 0 ? void 0 : _a.value) || 1;
    var kFactor = maximum / Math.log(numberOfYTicks + 1);
    function log(value) {
        return kFactor * Math.log(value + 1);
    }
    function exp(value) {
        return Math.exp(value / kFactor) - 1;
    }
    return { log: log, exp: exp };
};
exports.useBarLogScale = useBarLogScale;
var chartHooks = {
    computeMaxNumberOfTicks: computeMaxNumberOfTicks,
    useBarLogScale: exports.useBarLogScale,
    useDateAxisTicks: exports.useDateAxisTicks,
};
exports.default = chartHooks;
